import apisauce from "apisauce";
import AppConfig from "Config/AppConfig";

// ------------ Auxillary Functions ------------ //

const authPrefix = "Bearer";

const create = (baseURL = AppConfig.APIServer) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      Accept: "*/*"
    },
    timeout: 10000
  });

  // ------------ Your API calls ------------ //

  const testApi = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("test/");
  };

  const personalFixList = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("profile/posted-jobs");
  };

  const profile = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("profile/profile/");
  };

  const publicProfileApi = data => {
    api.deleteHeader("Authorization");
    return api.get(`profile/${data}`);
  };

  const profileUpdate = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.put("profile/profile/", { data });
  };

  const updateAvatarApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.put("profile/updateAvatar/", {
      avatar: data
    });
  };

  const deleteFixApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.delete(`profile/fixlist/feed/${data}`);
  };

  const profileReviewApi = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("profile/reviews/");
  };

  const giveProfileReviewApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("profile/reviews/", {
      data
    });
  };

  const subscribeUserApi = (token, data) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("subscribe/", { data: data });
  };

  const favouriteJobApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("profile/favouriteJob/", { data: data });
  };

  const getFavouriteJobApi = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("profile/favouriteJob");
  };

  const requestJobApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("profile/requestJob/", { data: data });
  };

  const getRequestJobApi = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("profile/requested-jobs/");
  };

  const getRequestDetailsApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("profile/jobRequestDetail/", {
      id: data
    });
  };

  const acceptRequestApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("profile/acceptRequest/", {
      fix_id: data.fixId,
      fixer_id: data.fixerId
    });
  };

  const getProfileLinksApi = id => {
    api.deleteHeader("Authorization");
    return api.get(`profile/profile-links/${id}`);
  };

  const updateProfileLinksApi = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`profile/profile-links/`, {
      resources: Object.values(data)
    });
  };

  // ------------ Return all APIs ------------ //

  return {
    // Insert API calls here
    testApi,
    profile,
    publicProfileApi,
    profileUpdate,
    personalFixList,
    deleteFixApi,
    profileReviewApi,
    giveProfileReviewApi,
    updateAvatarApi,
    subscribeUserApi,
    favouriteJobApi,
    getFavouriteJobApi,
    requestJobApi,
    getRequestJobApi,
    getRequestDetailsApi,
    acceptRequestApi,
    getProfileLinksApi,
    updateProfileLinksApi
  };
};

// ------------ Main Export ------------ //

export default {
  create
};
